import { render, staticRenderFns } from "./NewDashboardLayout.vue?vue&type=template&id=707ffe5c&"
import script from "./NewDashboardLayout.vue?vue&type=script&lang=js&"
export * from "./NewDashboardLayout.vue?vue&type=script&lang=js&"
import style0 from "./NewDashboardLayout.vue?vue&type=style&index=0&id=707ffe5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports